export default __webpack_public_path__ + "static/media/assembly_1.08a42f73.webp";